import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { USER_TIERS } from '../contexts/AuthContext';
import TestZone from '../features/lab/TestZone';
import FileUpload from '../features/lab/FileUpload';
import TerminalPage from '../features/lab/terminal/TerminalPage';
import AuthRedirect from '../shared/AuthRedirect';
import ProtectedRoute from '../shared/ProtectedRoute';
import SubMenu from '../shared/SubMenu';
import { LAB_MENU_ITEMS } from '../config/menuConfig';

const LabRouter = () => {
  return (
    <>
      <SubMenu items={LAB_MENU_ITEMS} />
      <Routes>
        <Route path="/" element={<Navigate to="/test-zone" replace />} />
        <Route
          path="/test-zone"
          element={
            <ProtectedRoute requiredTiers={[USER_TIERS.ADMIN, USER_TIERS.FAMILY]}>
              <TestZone />
            </ProtectedRoute>
          }
        />
        <Route
          path="/file-upload"
          element={
            <ProtectedRoute requiredTiers={[USER_TIERS.ADMIN, USER_TIERS.FAMILY]}>
              <FileUpload />
            </ProtectedRoute>
          }
        />
        <Route
          path="/terminal"
          element={
            <ProtectedRoute requiredTiers={[USER_TIERS.ADMIN, USER_TIERS.FAMILY]}>
              <TerminalPage />
            </ProtectedRoute>
          }
        />
        {/* 인증 관련 경로는 auth.ilouli.com으로 리다이렉트 */}
        <Route path="/profile" element={<AuthRedirect path="/profile" />} />
        <Route path="/login" element={<AuthRedirect path="/login" />} />
      </Routes>
    </>
  );
};

export default LabRouter;
